// WordPress adapter — admin-bar offset sync. Pairs with adapters/_wordpress.scss.
// No-ops unless WP has put .admin-bar on <body>. On small screens the admin bar
// scrolls away, so the fixed-header offset must track its live position.

const MOBILE_ADMIN_BAR_MQ = '(max-width: 600px)';

export function initWordPress() {
	if (!document.body.classList.contains('admin-bar')) return;

	const mq = window.matchMedia(MOBILE_ADMIN_BAR_MQ);

	const sync = () => {
		const root = document.documentElement;

		if (!mq.matches) {
			root.style.removeProperty('--wp-admin-bar-fixed-offset');
			return;
		}

		const adminBar = document.getElementById('wpadminbar');
		if (!adminBar) return;

		const bottom = Math.max(0, Math.round(adminBar.getBoundingClientRect().bottom));
		root.style.setProperty('--wp-admin-bar-fixed-offset', `${bottom}px`);
	};

	window.addEventListener('scroll', sync, { passive: true });
	window.addEventListener('resize', sync, { passive: true });
	window.addEventListener('pageshow', sync);
	sync();
}
